import { Block } from 'ui-kit/blocks'
import { Heading, Text } from 'ui-kit/typography'
import { UniversalIntegrations } from 'routes/components/Features/UniversalIntegrations'
import classes from './DifferenceSetup.module.scss'

export const DifferenceSetup = () => {
  return (
    <Block as={'section'} pad={'baseMob'} className={classes.section}>
      <hgroup className={classes.heading}>
        <Heading as={'h2'} size={'xl'} center balance className={classes.title}>
          Works for every customer setup
        </Heading>
        <Text size={'lg'} center balance className={classes.subtitle}>
          The problem with Unified API is that they are too unified. Each of
          your customers can have their own setup and Unified APls break. That
          is why we let you seamlessly customize Universal Integrations for
          every customer while keeping unification on your app's side.
        </Text>
      </hgroup>

      <UniversalIntegrations />
    </Block>
  )
}
